"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../constants");
exports.default = theme => ({
    root: {
        flexShrink: 0,
        position: 'relative',
        width: '100%',
        height: 'auto',
        appearance: 'none',
        color: theme.grey5,
        backgroundColor: 'transparent',
        boxSizing: 'border-box',
        cursor: 'pointer',
        outline: 'none',
        display: 'block',
        boxShadow: `0 0 0 0 ${theme.indigoPastel2}`,
        transition: `color 100ms linear 0ms`,
        '&::before': {
            content: '""',
            position: 'absolute',
            width: constants_1.MIN_TARGET_SIZE,
            height: constants_1.MIN_TARGET_SIZE,
            top: '50%',
            left: '50%',
            transform: 'translateY(-50%) translateX(-50%)'
        },
        '&[disabled]': {
            opacity: 0.3,
            color: theme.grey3
        },
        '&:not([disabled]):hover': {
            cursor: 'pointer',
            color: theme.indigo3
        }
    },
    avatar: {
        position: 'relative',
        padding: 1
    }
});
//# sourceMappingURL=avatar.group.button.style.js.map